export const MESSAGES = {
    LoginSuccess: 'You are logged in successfully',
    LoginFailed: 'Please enter valid creadentials',
    DefaultError: 'Something went wrong, please try again.',
    RegisterSuccess: 'You are registered successfully.',
    RegisterFailed: 'Some issue in Registration',
    CommingSoon:'This section will be coming soon.'
}